<script setup lang="ts">
import type { MaterialTrimmed } from "~/common/interfaces/material-trimmed";

const props = defineProps({
	materials: {
		type: Array as PropType<MaterialTrimmed[]>,
		default () {
			return [];
		}
	}
});
const emit = defineEmits<{(event: "change:material", material: MaterialTrimmed): void }>();

const selectedMaterial = ref(0);

const updateMaterial = (material: MaterialTrimmed) => {
	selectedMaterial.value = material.id;

	emit("change:material", material);
};

if (props.materials.length) {
	updateMaterial(props.materials[0]);
}
</script>

<template>
	<ul class="flex flex-wrap gap-3">
		<li v-for="(material) in materials" :key="material.id">
			<AppRadioMaterial
				:material="material"
				:model-value="selectedMaterial.toString()"
				:value="material.id.toString()"
				@change="updateMaterial(material)"
			/>
		</li>
	</ul>
</template>
